import { render } from "./IE.vue?vue&type=template&id=6b459328&scoped=true"
import script from "./IE.vue?vue&type=script&lang=js"
export * from "./IE.vue?vue&type=script&lang=js"

import "./IE.vue?vue&type=style&index=0&id=6b459328&scoped=true&lang=css"

import exportComponent from "/home/ec2-user/c2stem-server/client/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-6b459328"]])

export default __exports__